import { render } from "./RecordHelpDialog.vue?vue&type=template&id=41dd736c"
import script from "./RecordHelpDialog.vue?vue&type=script&lang=js"
export * from "./RecordHelpDialog.vue?vue&type=script&lang=js"

import "./RecordHelpDialog.vue?vue&type=style&index=0&id=41dd736c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/RecordHelpDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41dd736c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41dd736c', __exports__)) {
    api.reload('41dd736c', __exports__)
  }
  
  module.hot.accept("./RecordHelpDialog.vue?vue&type=template&id=41dd736c", () => {
    api.rerender('41dd736c', render)
  })

}


export default __exports__